<template>
    <div class="corporate-collaborator-form">
        <section class="corporate-dialog__section">
            <p class="corporate-dialog__section-label">{{ labels.sectionPersonal }}</p>
            <div class="corporate-dialog__section-body">
                <div class="corporate-collaborator-form__photo">
                    <img
                        class="corporate-collaborator-form__photo-img"
                        :src="photoPreview"
                        alt=""
                    />
                    <v-file-input
                        :model-value="photoFile"
                        accept="image/*"
                        :label="labels.photo"
                        variant="outlined"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi-camera"
                        clearable
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        @update:model-value="$emit('photo-change', $event)"
                        @click:clear="$emit('photo-clear')"
                    />
                </div>
                <div class="corporate-dialog__row">
                    <v-text-field
                        :model-value="modelValue.name"
                        :label="labels.name"
                        :placeholder="t.collaborators.placeholders.name"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        @update:model-value="patch('name', $event)"
                    />
                    <v-text-field
                        :model-value="modelValue.email"
                        :label="labels.email"
                        :placeholder="t.collaborators.placeholders.email"
                        type="email"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        @update:model-value="patch('email', $event)"
                    />
                </div>
                <div class="corporate-dialog__row">
                    <v-text-field
                        :model-value="modelValue.socialNumber"
                        :label="labels.socialNumber"
                        :placeholder="t.collaborators.placeholders.socialNumber"
                        v-mask="'###.###.###-##'"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        @update:model-value="patch('socialNumber', $event)"
                    />
                    <v-text-field
                        :model-value="modelValue.idNumber"
                        :label="labels.idNumber"
                        :placeholder="t.collaborators.placeholders.idNumber"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        @update:model-value="patch('idNumber', $event)"
                    />
                </div>
                <div class="corporate-dialog__row">
                    <v-text-field
                        :model-value="modelValue.phone"
                        :label="labels.phone"
                        type="tel"
                        :placeholder="t.collaborators.placeholders.phone"
                        v-mask="'(##) #####-####'"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        @update:model-value="patch('phone', $event)"
                    />
                    <v-select
                        :model-value="modelValue.status"
                        :items="statusOptions"
                        item-title="text"
                        item-value="value"
                        :label="labels.status"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        @update:model-value="patch('status', $event)"
                    />
                </div>
                <div class="corporate-dialog__row corporate-dialog__row--3">
                    <v-text-field
                        :model-value="modelValue.postcode"
                        :label="labels.postcode"
                        :placeholder="t.collaborators.placeholders.postcode"
                        v-mask="'#####-###'"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        :loading="loadingAddress"
                        @update:model-value="patch('postcode', $event)"
                        @change="$emit('cep-change')"
                    />
                    <v-text-field
                        :model-value="modelValue.address"
                        :label="labels.address"
                        :placeholder="t.collaborators.placeholders.address"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        :loading="loadingAddress"
                        @update:model-value="patch('address', $event)"
                    />
                    <v-text-field
                        :model-value="modelValue.addressNumber"
                        :label="labels.addressNumber"
                        :placeholder="t.collaborators.placeholders.addressNumber"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        @update:model-value="patch('addressNumber', $event)"
                    />
                </div>
                <div class="corporate-dialog__row">
                    <v-text-field
                        :model-value="modelValue.addressComplement"
                        :label="labels.addressComplement"
                        :placeholder="t.collaborators.placeholders.addressComplement"
                        maxlength="100"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        @update:model-value="patch('addressComplement', $event)"
                    />
                    <v-text-field
                        :model-value="modelValue.neighborhood"
                        :label="labels.neighborhood"
                        :placeholder="t.collaborators.placeholders.neighborhood"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        :loading="loadingAddress"
                        @update:model-value="patch('neighborhood', $event)"
                    />
                </div>
                <div class="corporate-dialog__row corporate-dialog__row--3">
                    <v-text-field
                        :model-value="modelValue.city"
                        :label="labels.city"
                        :placeholder="t.collaborators.placeholders.city"
                        maxlength="255"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        :loading="loadingAddress"
                        @update:model-value="patch('city', $event)"
                    />
                    <v-select
                        :model-value="modelValue.county"
                        :items="brazilianStates"
                        item-title="nome"
                        item-value="sigla"
                        :label="labels.county"
                        :placeholder="t.collaborators.placeholders.selectState"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        :loading="loadingAddress"
                        @update:model-value="patch('county', $event)"
                    />
                    <v-select
                        :model-value="modelValue.country"
                        :items="countryOptions"
                        item-title="text"
                        item-value="value"
                        :label="labels.country"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        @update:model-value="patch('country', $event)"
                    />
                </div>
                <p v-if="showActivationNote" class="corporate-dialog__hint">
                    <v-icon size="small" class="me-1">mdi-email-alert-outline</v-icon>
                    {{ labels.emailActivationNote }}
                </p>
            </div>
        </section>

        <section v-if="showOrgSection" class="corporate-dialog__section">
            <p class="corporate-dialog__section-label">{{ labels.sectionOrg }}</p>
            <div class="corporate-dialog__section-body">
                <div class="corporate-dialog__row">
                    <v-select
                        :model-value="modelValue.sectorId"
                        :items="sectorSelectOptions"
                        item-title="text"
                        item-value="value"
                        :label="labels.sector"
                        variant="outlined"
                        density="compact"
                        clearable
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        @update:model-value="onSectorChange"
                    />
                    <v-select
                        :model-value="modelValue.roleId"
                        :items="filteredRoleOptions"
                        item-title="text"
                        item-value="value"
                        :label="labels.role"
                        variant="outlined"
                        density="compact"
                        clearable
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        @update:model-value="onRoleChange"
                    />
                </div>
                <div class="corporate-dialog__row">
                    <v-text-field
                        :model-value="modelValue.admissionDate"
                        :label="labels.admissionDate"
                        type="date"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        @update:model-value="patch('admissionDate', $event)"
                    />
                    <v-text-field
                        :model-value="modelValue.internalCode"
                        :label="labels.internalCode"
                        variant="outlined"
                        density="compact"
                        class="weeduc-admin-v-field"
                        hide-details="auto"
                        @update:model-value="patch('internalCode', $event)"
                    />
                </div>
                <v-switch
                    :model-value="modelValue.isResponsible"
                    color="primary"
                    hide-details
                    inset
                    :disabled="!canMarkResponsible"
                    :label="labels.responsibleSwitch"
                    @update:model-value="onResponsibleChange"
                />
                <p class="corporate-dialog__hint">{{ responsibleHintText }}</p>
            </div>
        </section>
    </div>
</template>

<script>
import { corporateI18n } from '@/i18n/mixins';
import { canMarkCollaboratorResponsible } from '@/utils/corporate/users';

export default {
    name: 'CollaboratorFormFields',
    mixins: [corporateI18n],
    props: {
        modelValue: { type: Object, required: true },
        labels: { type: Object, required: true },
        sectorOptions: { type: Array, default: () => [] },
        roleOptions: { type: Array, default: () => [] },
        rolesRaw: { type: Array, default: () => [] },
        statusOptions: { type: Array, default: () => [] },
        countryOptions: { type: Array, default: () => [] },
        brazilianStates: { type: Array, default: () => [] },
        photoFile: { default: null },
        photoPreview: { type: String, default: '' },
        loadingAddress: { type: Boolean, default: false },
        showActivationNote: { type: Boolean, default: false },
        showOrgSection: { type: Boolean, default: true },
    },
    emits: ['update:modelValue', 'photo-change', 'photo-clear', 'cep-change', 'sector-change'],
    computed: {
        sectorSelectOptions() {
            return (this.sectorOptions || []).filter((o) => o.value);
        },
        filteredRoleOptions() {
            // roleOptions já vem filtrado pelo parent (API ?sectorId=).
            // Não filtrar de novo por sectorId em rolesRaw: a API de cargos
            // muitas vezes não devolve sectorId/parentId e isso esvazia o select.
            return (this.roleOptions || []).filter((o) => o.value);
        },
        canMarkResponsible() {
            return canMarkCollaboratorResponsible(this.modelValue);
        },
        responsibleHintText() {
            if (this.canMarkResponsible) return this.labels.responsibleHint;
            return this.labels.responsibleRequiresOrg || this.labels.responsibleHint;
        },
    },
    methods: {
        patch(key, value) {
            this.$emit('update:modelValue', {
                ...this.modelValue,
                [key]: value,
            });
        },
        onResponsibleChange(value) {
            if (!this.canMarkResponsible) return;
            const isResponsible = Boolean(value);
            this.$emit('update:modelValue', {
                ...this.modelValue,
                isResponsible,
                manager: isResponsible ? 1 : 0,
            });
        },
        onRoleChange(roleId) {
            const next = { ...this.modelValue, roleId };
            if (!canMarkCollaboratorResponsible(next)) {
                next.isResponsible = false;
                next.manager = 0;
            }
            this.$emit('update:modelValue', next);
        },
        onSectorChange(sectorId) {
            const next = { ...this.modelValue, sectorId, roleId: null };
            if (!canMarkCollaboratorResponsible(next)) {
                next.isResponsible = false;
                next.manager = 0;
            }
            this.$emit('update:modelValue', next);
            this.$emit('sector-change', sectorId);
        },
    },
};
</script>

<style scoped>
.corporate-collaborator-form__photo {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.corporate-collaborator-form__photo-img {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    object-fit: cover;
    flex-shrink: 0;
    background: #f0f2f5;
    border: 1px solid #e8eaf0;
}

.corporate-collaborator-form__photo .weeduc-admin-v-field {
    flex: 1;
    min-width: 0;
}

.corporate-dialog__row--3 {
    grid-template-columns: 1fr 2fr 1fr;
}

@media (max-width: 700px) {
    .corporate-collaborator-form__photo {
        flex-direction: column;
        align-items: stretch;
    }

    .corporate-dialog__row--3 {
        grid-template-columns: 1fr;
    }
}
</style>
